import React, { useState, useEffect } from 'react';
import NavigationBar from '../components/NavigationBar';
import { getTimelineEntries } from '../api/api';
import './History.css';

const STRAPI_URL = process.env.REACT_APP_STRAPI_API_URL;

function getImageUrl(entry) {
  const formats = entry.image?.formats;
  if (!formats && !entry.image?.url) return null;
  const isMobile = window.innerWidth < 768;
  if (isMobile) {
    return STRAPI_URL + (formats?.small?.url || formats?.medium?.url || entry.image?.url);
  }
  return STRAPI_URL + (formats?.large?.url || formats?.medium?.url || entry.image?.url);
}

const History = () => {
  const [activeEntry, setActiveEntry] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTimelineEntries().then(data => {
      if (data?.data) {
        setTimeline(data.data);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') setActiveEntry(null);
    };
    if (activeEntry) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [activeEntry]);

  return (
    <>
      <NavigationBar />

      <div className="history-page">
        <header className="history-header">
          <h1>Historie des Rosa-Luxemburg-Platzes</h1>
          <p className="history-lede">
            Vom Scheunenviertel über den Bülowplatz und Horst-Wessel-Platz zum
            Rosa-Luxemburg-Platz – drei Jahrhunderte Berliner Geschichte an einem Ort.
          </p>
        </header>

        {loading ? (
          <p style={{ color: '#718096' }}>Lade Historie...</p>
        ) : (
          <ol className="timeline">
            {timeline.map((entry, i) => (
              <li key={entry.id || i} className="timeline-item">
                <span className="timeline-year">{entry.year}</span>
                <div className="timeline-content">
                  <h2>{entry.title}</h2>
                  <p>
                    {entry.body}
                    {entry.detail && (
                      <>
                        {' '}
                        <button
                          className="weiterlesen-btn"
                          onClick={() => {
                            setActiveEntry(entry);
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: 'weiterlesen_click',
                              entry_title: entry.title,
                              entry_year: entry.year,
                            });
                          }}
                        >
                          Weiterlesen&nbsp;…
                        </button>
                      </>
                    )}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        )}

        <footer className="history-footer">
          <p>
            Quellen: kuratierte Recherche aus öffentlichen Archiven, OpenStreetMap,
            Stadtgeschichte Berlin-Mitte. Die zugehörigen Orte (Volksbühne, Babylon,
            Karl-Liebknecht-Haus &hellip;) sind in der Karte verortet.
          </p>
        </footer>
      </div>

      {activeEntry && (
        <div
          className="detail-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setActiveEntry(null); }}
        >
          <div className="detail-panel">
            <button
              className="detail-close"
              onClick={() => setActiveEntry(null)}
              aria-label="Schliessen"
            >
              ✕
            </button>
            <span className="detail-year">{activeEntry.year}</span>
            <h2 className="detail-title">{activeEntry.title}</h2>
            {activeEntry.image && (
              <figure className="detail-figure">
                <img
                  src={getImageUrl(activeEntry)}
                  alt={activeEntry.imageCaption || activeEntry.title}
                  className="detail-img"
                />
                {activeEntry.imageCaption && (
                  <figcaption className="detail-caption">{activeEntry.imageCaption}</figcaption>
                )}
              </figure>
            )}
            <div className="detail-body">
              {activeEntry.detail && activeEntry.detail.split('\n').map((para, i) =>
                para.trim() ? <p key={i}>{para}</p> : null
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default History;
